import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState({ logo_light: null, logo_dark: null });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/brand");
      setBrand({ logo_light: data.logo_light, logo_dark: data.logo_dark });
    } catch {
      // keep defaults
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <BrandContext.Provider value={{ brand, refreshBrand: load, setBrand }}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBrand = () => useContext(BrandContext);
